<nz-spin [nzSpinning]="loading$ | async">
  <div class="body-container">
    <div
      class="custom-data-wrapper mb-16"
      [ngClass]="{ 'no-border': notes.length === 0 }">
      <div class="data" *ngFor="let incident of notes">
        <div class="display-flex">
          <div class="mr-8">
            <nz-avatar
              class="avtar"
              nzSlot="nzAvatar"
              [nzText]="generateAlias(incident.createdByName)"
              nzShape="circle"></nz-avatar>
          </div>
          <div class="w-100">
            <div
              class="display-flex justify-content-between"
              nzAlign="middle"
              style="margin-bottom: 8px">
              <strong>{{ incident.createdByName | titlecase }}</strong>
              <span class="text s-12">
                {{ incident.createdOn | userDate: 'MM/dd/yyyy hh:mm a' }}
              </span>
            </div>

            <div
              class="display-flex input-container"
              style="margin: 0"
              *ngIf="
                !selectedNoteData ||
                (!!selectedNoteData && selectedNoteData.id !== incident.id)
              ">
              <div class="w-100 mr-10 description">{{ incident.comment }}</div>
              <ng-container *ngIf="incident.createdBy === userId">
                <button
                  class="mr-10"
                  nz-button
                  type="button"
                  nzType="text"
                  (click)="selectNote(incident)">
                  <svg-icon
                    [title]="'Edit Note'"
                    src="/assets/icon/icon-edit.svg"
                    class="icon s-20 mr-8">
                  </svg-icon>
                </button>
                <button
                  class="mr-10"
                  (click)="deleteNote(incident)"
                  nz-button
                  type="button"
                  nzType="text">
                  <svg-icon
                    [title]="'Delete Note'"
                    src="/assets/icon/icon-trash.svg"
                    class="icon s-20">
                  </svg-icon>
                </button>
              </ng-container>
            </div>
            <div
              *ngIf="!!selectedNoteData && selectedNoteData.id === incident.id">
              <nz-form-item>
                <nz-form-control nzErrorTip="Please enter note!">
                  <div class="display-flex">
                    <input
                      class="mr-10"
                      name="updateNote"
                      type="text"
                      nz-input
                      [(ngModel)]="updateNote"
                      id="updateNote"
                      placeholder="Type Note" />
                    <button
                      class="mr-10 primary-text-btn"
                      nz-button
                      type="button"
                      [disabled]="
                        updateNote.trim().length === 0 ||
                        updateNote.length > 2000
                      "
                      nzType="text"
                      (click)="editNote()">
                      Update
                    </button>
                    <button
                      class="mr-10"
                      nz-button
                      type="button"
                      nzType="text"
                      (click)="cancelSelection()">
                      Cancel
                    </button>
                  </div>
                  <div *ngIf="updateNote.length > 2000" class="error-text">
                    Note cannot exceed 2000 characters
                  </div>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </div>
      </div>
      <app-no-data
        *ngIf="notes.length === 0"
        [title]="'No Data'"
        [desc]="'Data Notes not found'"
        [icon]="'/assets/icon/icon-face-happy.svg'">
      </app-no-data>
    </div>
  </div>
  <div class="display-flex justify-content-between drawer-footer">
    <nz-form-item>
      <nz-form-control nzErrorTip="Please enter note!">
        <div class="display-flex">
          <input
            class="mr-10"
            name="note"
            type="text"
            nz-input
            [(ngModel)]="note"
            id="note"
            placeholder="Type Note" />
          <button
            nz-button
            type="button"
            title="Click to add a new note"
            [disabled]="note.trim().length === 0 || note.length > 2000"
            nzType="text"
            (click)="addNote()">
            <svg-icon
              class="icon s-20"
              src="assets/icon/icon-send.svg"></svg-icon>
          </button>
        </div>
        <div *ngIf="note.length > 2000" class="error-text">
          Note cannot exceed 2000 characters
        </div>
      </nz-form-control>
    </nz-form-item>
  </div>
</nz-spin>

<app-confirm-dialog
  [isVisible]="showConfirmDialog"
  [title]="'Delete Note'"
  message="Are you sure you want to delete this note?"
  [iconSrc]="'/assets/icon/icon-trash-red.svg'"
  [iconColor]="'red'"
  [cancelText]="'Cancel'"
  [confirmText]="'Delete'"
  [loading]="(loading$ | async) || false"
  (confirmed)="handleDelete()"
  (cancelled)="handleCancelDelete()"
  (closed)="handleCancelDelete()">
</app-confirm-dialog>
